import React from 'react';

type Props = {
  children: React.ReactNode;
  active?: boolean;
};

function Step(props: Props) {
  return <span className="ml-4 text-sm font-medium">{props.children}</span>;
}

export default Step;
